
export function setMessagteTextAreaToDefault() {
    const teaxtAreaEl = $($(".bottom-actions .message-textarea")[0])
    teaxtAreaEl.attr("rows", 1);
    teaxtAreaEl.removeAttr("style");
}




export function addActionElementToBottomSender(addElement: HTMLElement | JQuery<HTMLElement>) {
    $(".chat-dialog").addClass("action-extend");

    $(".bottom-sender .action-bottom-sender-block").remove();
    let bottomSenderEl = $(".bottom-sender");
    $(bottomSenderEl[0]).prepend(addElement);
}

export function deleteActionElementFromBottomSender(className: string) {
    $(".chat-dialog").removeClass("action-extend");
    $(`.bottom-sender .${className}`).remove();
}

export function deleteActionElementFromBottomSenderNoArg() {
    $(".chat-dialog").removeClass("action-extend");
    $(`.bottom-sender .action-bottom-sender-block`).remove();
}



export function messageTextArea() {
    const textArea = $(".message-textarea");
    return textArea;
}


